<template>
  <ValidationObserver
    ref="validationObserver"
    v-slot="{ handleSubmit }"
  >
    <form
      v-if="isFormAvailable()"
      class="contact-info"
      novalidate="novalidate"
      @submit.prevent="handleSubmit(submit)"
      @input="handleFormChange"
    >
      <div class="edit-button-wrapper">
        <Button
          :title="'Apply'"
          :classType="'primary'"
          :type="'submit'"
        />
      </div>
      <div class="breadcrumbs">
        <span class="system">
          System Management
        </span>
        <span>
          / Subscription Policies
        </span>
      </div>
      <div class="title">
        Subscription Policies
      </div>
      <div>
        <Tabs
          :smallStyle="true"
          :isLong="true"
        >
          <Tab
            name="General"
            :selected="true"
            className="tab"
          >
            <MaterialSelect
              v-model="formData.entitlementFeature"
              v-bind="formFields.entitlementFeature"
              :options="entitlementsFeaturesOptions"
              :withEmptyField="false"
            />
          </Tab>
        </Tabs>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import {
  mapGetters,
  mapState,
} from 'vuex';
import BaseForm from './BaseForm.vue';
import MaterialSelect from '../inputs/MaterialSelect.vue';
import CONFIG from '../../constants/config';
import { SET_EDIT_FORM } from '../../store/actions/common';
import {
  GET_ACCOUNT_SETTINGS_REQUEST,
  EDIT_ACCOUNT_SETTINGS_REQUEST,
} from '../../store/actions/accountsActions/accounts';
import Button from '../common/Button.vue';
import Tabs from '../common/Tabs/Tabs.vue';
import Tab from '../common/Tabs/Tab.vue';

export default {
  name: 'SubscriptionPoliciesForm',
  components: {
    MaterialSelect,
    Button,
    Tabs,
    Tab,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'subscriptionPolicies',
    },
  },
  data() {
    return {
      formData: {
        entitlementFeature: '0',
      },
      formFields: {
        entitlementFeature: {
          name: 'entitlementFeature',
          formPrefix: this.formPrefix,
          rules: {
            required: false,
          },
        },
      },
      errorMapping: {
        entitlementFeature: [
          `${this.formPrefix}.entitlementFeature`,
        ],
      },
      submitEvent: EDIT_ACCOUNT_SETTINGS_REQUEST,
      successMessage: CONFIG.successMessages.editAccountMessage,
      errorMessage: CONFIG.errorMessages.commonServerError,
      accountTimezone: '',
    };
  },
  computed: {
    ...mapState({
      entitlementsFeatures: (state) => state.accounts.entitlementsFeatures,
    }),
    ...mapGetters([
      'getCurrentAccountId',
    ]),
    entitlementsFeaturesOptions() {
      const features = this.entitlementsFeatures.map((item) => ({
        code: item.id,
        name: item.name,
      }));

      return [
        {
          code: '0',
          name: 'No Entitlement Required',
        },
        ...features,
      ];
    },
  },
  mounted() {
    const s = this.$route.name;
    document.title = s[0].toUpperCase() + s.slice(1);

    const {
      errorMessages,
      statuses,
    } = CONFIG;

    this.$store.dispatch(GET_ACCOUNT_SETTINGS_REQUEST, this.getCurrentAccountId)
      .then((res) => this.initFormData(res))
      .catch((err) => {
        if (err.error === errorMessages.unknown) {
          this.$router.push(`/${statuses.notFound}`);
        }
      });
  },
  methods: {
    isFormAvailable() {
      return this.entitlementsFeatures
        && this.entitlementsFeatures.length;
    },
    initFormData(account) {
      if (account.defaultEntitlementFeatureId) {
        this.formData.entitlementFeature = account.defaultEntitlementFeatureId;
      }

      this.accountTimezone = account.timezone;
    },
    getRequestData() {
      const formData = {
        defaultEntitlementFeatureId: this.formData.entitlementFeature === '0'
          ? null
          : this.formData.entitlementFeature,
        timezone: this.accountTimezone,
      };

      return {
        accountId: this.getCurrentAccountId,
        data: formData,
      };
    },
    handleFormChange() {
      this.$store.dispatch(SET_EDIT_FORM, true);
    },
  },
};
</script>

<style scoped>
  .btn-container {
    margin-bottom: 20px;
  }

  .text {
    color: #4b4f55;
  }

  .edit-button-wrapper {
    display: flex;
    align-items: center;
    position: absolute;
    right: 26px;
  }

  .breadcrumbs {
    margin-bottom: 25px;
  }

  .system {
    color: #4c5057;
  }
</style>
